
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { name: '首页', path: '/' },
    { name: '关于我们', path: '/about' },
    { name: '产品中心', path: '/products' },
    { name: '信任体系', path: '/trust' },
    { name: '荣誉见证', path: '/honors' },
    { name: '尊贵服务', path: '/consultation' },
    { name: '渠道合作', path: '/join' }
  ];

  const handleNavClick = (path: string) => {
    // 延迟执行滚动，确保路由切换完成
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 100);
    
    // 关闭移动端菜单
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-[#663333] text-white shadow-xl z-50 backdrop-blur-sm">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center space-x-3 focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-0 rounded-lg p-2 -m-2 transition-all duration-200"
            onClick={() => handleNavClick('/')}
          >
            <div className="text-2xl font-bold text-[#cc9966]" style={{ fontFamily: '"Trajan Pro", serif' }}>
              顺年陈
            </div>
            <div className="text-sm text-[#cc9966] opacity-80">
              Shunnian Chen
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-white hover:text-[#cc9966] transition-colors duration-300 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-0 rounded px-3 py-2 relative"
                onClick={() => handleNavClick(item.path)}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-0 rounded transition-all duration-200"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <div className="w-6 h-6 flex flex-col justify-center space-y-1">
              <div className={`h-0.5 bg-white transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></div>
              <div className={`h-0.5 bg-white transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></div>
              <div className={`h-0.5 bg-white transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></div>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-[#774444]">
            <div className="flex flex-col space-y-3 pt-4">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="text-white hover:text-[#cc9966] transition-colors duration-300 cursor-pointer py-2 focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-0 rounded px-3"
                  onClick={() => handleNavClick(item.path)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
